import { render, staticRenderFns } from "./addDhActive.vue?vue&type=template&id=7b678972&"
import script from "./addDhActive.vue?vue&type=script&lang=js&"
export * from "./addDhActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports